$(document).ready(function(){
   
    $('#smallnavmenu').find('.menu-item-has-children, .page_item').hover(
        function() {
    $(this).children( "ul" ).css("display", "grid" );
        }, function() {
    $( this ).children( "ul" ).css("display", "none" );
  }
    );
    
});